import React, { useEffect } from 'react';
import DashboardTemplate from '@/components/templates/DashboardTemplate';
import { setBreadcrumbs } from '@/store/slices/breadcrumb';
import { PAGE } from '@/routes';
import { useDispatch } from 'react-redux';

const DashboardPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Set breadcrumbs when component mounts
    dispatch(
      setBreadcrumbs([
        {
          title: 'Dashboard',
          path: PAGE.DASHBOARD.path
        }
      ])
    );
  }, [dispatch]);

  return <DashboardTemplate>DashboardPage</DashboardTemplate>;
};

export default DashboardPage;
